// extracted by mini-css-extract-plugin
module.exports = {"holder":"content_holder__3cSxd","sec":"content_sec__3BKj5"};